export interface TimeZoneOption {
  value: string
  label: string
}

interface Props {
  currency: string
  currencies: string[]
  onCurrencyChange: (value: string) => void
  timeZone: string
  timeZones: TimeZoneOption[]
  onTimeZoneChange: (value: string) => void
}

const LABEL = "block text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1"
const SELECT = "w-full border border-border rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-ring"

// Settings only a country node (directly under the root) carries.
export default function CountryFields({ currency, currencies, onCurrencyChange, timeZone, timeZones, onTimeZoneChange }: Props) {
  return (
    <>
      <div>
        <label className={LABEL}>Currency</label>
        <select className={SELECT} value={currency} onChange={(e) => onCurrencyChange(e.target.value)}>
          {currencies.map((code) => <option key={code} value={code}>{code}</option>)}
        </select>
        <p className="text-xs text-muted-foreground mt-1">
          Country nodes (directly under the root) carry the currency used across that country.
        </p>
      </div>
      <div>
        <label className={LABEL}>Time zone</label>
        <select className={SELECT} value={timeZone} onChange={(e) => onTimeZoneChange(e.target.value)}>
          <option value="">UTC (not set)</option>
          {timeZones.map((tz) => <option key={tz.value} value={tz.value}>{tz.label}</option>)}
        </select>
        <p className="text-xs text-muted-foreground mt-1">
          Decides when "today" starts for this country on Plan vs Actual and the sales sync.
        </p>
      </div>
    </>
  )
}
